module.exports = __webpack_public_path__ + "static/media/img-signature.711a7c82.png";